import { render, staticRenderFns } from "./ModalGerenciarEstoque.vue?vue&type=template&id=544d553a&scoped=true"
import script from "./ModalGerenciarEstoque.vue?vue&type=script&lang=js"
export * from "./ModalGerenciarEstoque.vue?vue&type=script&lang=js"
import style0 from "./ModalGerenciarEstoque.vue?vue&type=style&index=0&id=544d553a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544d553a",
  null
  
)

export default component.exports